export const initialState = {
  notificaciones: {
    listado: [],
    publicaciones: null,
    grupos: [],
    ntf: [],
    loading: false,
  },
  mensajes: {
    mensaje: "",
    variant: "success",
  },
  usuario: {
    cargando: false,
    error: "",
    isLogged: false,
    usuario: "",
    id: 0,
    nombre: "",
  },
  lista: {
    fecha: new Date(1, 1, 1),
    listado: [],
  },
  diasjefe: {
    listado: [],
  },
  dias: {
    listado: {
      feriados: [],
      guardados: [],
      solicitudes: [],
    },
  },
  anticipos: {
    listado: [],
  },
  elementos: {
    listado: [],
    elementos: [],
  },
  vehiculo: {
    pool: [],
    propios: [],
    movil: null,
    propiedades: [],
    opciones: [],
    cargando: false,
  },
};
